module.exports = __webpack_public_path__ + "img/Nora-login_dark.610237.svg";